export default "__VITE_ASSET__Dppn1Nzq__"